const Upcoming = () => {
	return (
		<div className="grid h-40 place-items-center">
			<div>This integration is in active development.</div>
		</div>
	);
};

export default Upcoming;
